// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__pMVSw","btnContainer":"styles_btnContainer__GUd0e"};